function renderCalendar(R){
const yEl=document.getElementById('calYear'); if(yEl)yEl.textContent=R.ty;
const wd=['L','M','M','J','V','S','D'];
const moisNoms=['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
const t=new Date(), tY=t.getFullYear(), tM=t.getMonth()+1, tD=t.getDate();
let lg=''; for(let n=1;n<=9;n++){lg+=`<span class="lg"><span class="sw" style="background:${colorVar(n)}"></span>${n} · ${NAMES[n]||''}</span>`;}
const lgEl=document.getElementById('calLegend'); if(lgEl)lgEl.innerHTML=lg;
let html='';
for(let m=1;m<=12;m++){
const pmonth=R.moisAnnee[m-1];
const offset=(new Date(R.ty,m-1,1).getDay()+6)%7;
const ndays=new Date(R.ty,m,0).getDate();
let cells='';
for(let i=0;i<offset;i++)cells+='<div class="cal-d empty"></div>';
for(let d=1;d<=ndays;d++){
const pd=reduce1(pmonth+d);
const today=(R.ty===tY&&m===tM&&d===tD);
cells+=`<div class="cal-d${today?' today':''}" title="${d} ${moisNoms[m-1]} — jour personnel ${pd}"><span class="dd">${d}</span><span class="pn" style="color:${colorVar(pd)}">${pd}</span></div>`;
}
html+=`<div class="cal-m"><div class="cm-h">${moisNoms[m-1]}</div>
<div class="cal-week">${wd.map(w=>`<span>${w}</span>`).join('')}</div>
<div class="cal-days">${cells}</div></div>`;
}
const g=document.getElementById('calGrid'); if(g)g.innerHTML=html;
}
async function downloadPDF(btn){
const msg=document.getElementById('leadMsg');
if(!THEME){return}
if(typeof window.html2canvas==='undefined'||!window.jspdf){
msg.className='lead-msg ko';msg.textContent='Le module PDF charge encore, réessayez dans un instant.';return;
}
const old=btn?btn.textContent:'';if(btn){btn.disabled=true;btn.textContent='Préparation du PDF…';}

function pdfClonefix(cd){
const ns=[cd.documentElement,cd.body,...cd.querySelectorAll('*')];
const ps=['color','backgroundColor','borderColor','borderTopColor','borderBottomColor','borderLeftColor','borderRightColor','outlineColor','fill','stroke'];
ns.forEach(el=>{if(!el||!el.style)return;const cs=window.getComputedStyle(el);ps.forEach(p=>{try{const v=cs[p];if(!v)return;el.style[p]=v.includes('oklch')?'rgb(0,0,0)':v;}catch(e){}});});
}

const R=THEME;
const pf=v=>PARFUMS[v]||PARFUMS[reduceM(v)];
const ed=new Date().toLocaleDateString('fr-FR');

const css=`
#pdfPrintRoot{position:fixed;left:-99999px;top:0;background:#fff;z-index:-1}
#pdfPrintRoot,#pdfPrintRoot *{box-sizing:border-box}
#pdfPrintRoot .pg{width:210mm;height:297mm;background:#fff;position:relative;overflow:hidden;font-family:'Jost',sans-serif;color:#1d1d1b}
#pdfPrintRoot .pg-cover{background:#0c0c0c;color:#f3efe9;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center}
#pdfPrintRoot .pg-cover img{height:44px;margin-bottom:32px}
#pdfPrintRoot .pg-cover .kicker{font-size:9pt;letter-spacing:.34em;text-transform:uppercase;opacity:.55;margin-bottom:20px}
#pdfPrintRoot .pg-cover h1{font-family:'Cormorant Garamond',serif;font-weight:500;font-size:32pt;line-height:1.18;margin-bottom:28px;letter-spacing:.008em;max-width:130mm}
#pdfPrintRoot .pg-cover .rule{width:52px;height:1px;background:rgba(243,239,233,.35);margin:0 auto 28px}
#pdfPrintRoot .pg-cover .nm{font-family:'Cormorant Garamond',serif;font-size:17pt;letter-spacing:.03em;margin-bottom:9px}
#pdfPrintRoot .pg-cover .dob{font-size:9pt;letter-spacing:.1em;opacity:.6;text-transform:uppercase}
#pdfPrintRoot .pg-cover .ed{position:absolute;bottom:24mm;font-size:8pt;font-style:italic;opacity:.4;letter-spacing:.03em}

#pdfPrintRoot .pg-content{padding:24mm 22mm 20mm;height:100%;position:relative}
#pdfPrintRoot .kicker-row{display:flex;justify-content:space-between;align-items:baseline;border-bottom:.7pt solid rgba(29,29,27,.25);padding-bottom:5mm;margin-bottom:11mm}
#pdfPrintRoot .kicker-row span{font-size:7.5pt;letter-spacing:.26em;text-transform:uppercase;color:#86857d}
#pdfPrintRoot h1.pg-title{font-family:'Cormorant Garamond',serif;font-weight:500;font-size:24pt;letter-spacing:.008em;margin-bottom:5mm}
#pdfPrintRoot .pg-intro{font-size:9.5pt;line-height:1.6;color:#3a3a37;max-width:135mm;margin-bottom:11mm}
#pdfPrintRoot .pg-intro strong{color:#1d1d1b;font-weight:600}

#pdfPrintRoot .col3{display:grid;grid-template-columns:repeat(3,1fr);column-gap:9mm}
#pdfPrintRoot .colcard{border-left:.7pt solid rgba(29,29,27,.22);padding-left:6mm}
#pdfPrintRoot .colcard .k{font-size:7pt;letter-spacing:.2em;text-transform:uppercase;color:#86857d;margin-bottom:6mm}
#pdfPrintRoot .colcard .big{font-family:'Cormorant Garamond',serif;font-size:46pt;line-height:1;margin-bottom:5mm}
#pdfPrintRoot .colcard .nm{font-size:8pt;letter-spacing:.14em;text-transform:uppercase;color:#9a824f;margin-bottom:6mm}
#pdfPrintRoot .colcard .desc{font-size:8.5pt;line-height:1.55;color:#3a3a37;margin-bottom:7mm}
#pdfPrintRoot .colcard .pf{font-family:'Cormorant Garamond',serif;font-size:10.5pt;font-style:italic;color:#1d1d1b}

#pdfPrintRoot .rows3{display:flex;flex-direction:column}
#pdfPrintRoot .row3{display:grid;grid-template-columns:32mm 1fr;column-gap:8mm;padding:9mm 0;border-top:.7pt solid rgba(29,29,27,.2)}
#pdfPrintRoot .row3:last-child{border-bottom:.7pt solid rgba(29,29,27,.2)}
#pdfPrintRoot .row3 .num{font-family:'Cormorant Garamond',serif;font-size:38pt;line-height:1}
#pdfPrintRoot .row3 .meta{font-size:7pt;letter-spacing:.18em;text-transform:uppercase;color:#9a824f;margin-bottom:4mm}
#pdfPrintRoot .row3 .nmn{font-family:'Cormorant Garamond',serif;font-size:13pt;margin-bottom:3mm;display:block}
#pdfPrintRoot .row3 .tx{font-size:9pt;line-height:1.55;color:#3a3a37;margin-bottom:4mm}
#pdfPrintRoot .row3 .pf{font-family:'Cormorant Garamond',serif;font-size:10pt;font-style:italic}

#pdfPrintRoot .incl9{display:grid;grid-template-columns:repeat(3,1fr);gap:10mm;max-width:150mm;margin:0 auto 14mm}
#pdfPrintRoot .incl9 .cell{aspect-ratio:1;border:.7pt solid rgba(29,29,27,.22);display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative}
#pdfPrintRoot .incl9 .cell .idx{position:absolute;top:4mm;left:5mm;font-size:7.5pt;color:#86857d}
#pdfPrintRoot .incl9 .cell .v{font-family:'Cormorant Garamond',serif;font-size:34pt}
#pdfPrintRoot .incl9 .cell.absent .v{color:#c7c6bd}
#pdfPrintRoot .note{font-size:9pt;line-height:1.6;color:#3a3a37;max-width:135mm}
#pdfPrintRoot .note strong{color:#1d1d1b}

#pdfPrintRoot .bars4{display:flex;flex-direction:column;gap:16mm;margin-bottom:16mm;max-width:165mm}
#pdfPrintRoot .bar-row{display:grid;grid-template-columns:40mm 1fr 16mm;align-items:center;column-gap:6mm}
#pdfPrintRoot .bar-row .lb{font-size:9.5pt;letter-spacing:.1em;text-transform:uppercase;color:#3a3a37}
#pdfPrintRoot .bar-track{height:1.2pt;background:rgba(29,29,27,.15);position:relative}
#pdfPrintRoot .bar-fill{position:absolute;left:0;top:-1.4pt;height:4pt;background:#9a824f}
#pdfPrintRoot .bar-row .vv{font-family:'Cormorant Garamond',serif;font-size:20pt;text-align:right}

#pdfPrintRoot .years9{display:grid;grid-template-columns:repeat(3,1fr);gap:8mm}
#pdfPrintRoot .years9 .yc{border:.7pt solid rgba(29,29,27,.22);padding:8mm 6mm;text-align:center}
#pdfPrintRoot .years9 .yc.now{border-color:#1d1d1b;border-width:1.1pt}
#pdfPrintRoot .years9 .yc .y{font-size:7.5pt;letter-spacing:.1em;color:#86857d;margin-bottom:3mm}
#pdfPrintRoot .years9 .yc .yn{font-family:'Cormorant Garamond',serif;font-size:30pt;line-height:1.1;margin-bottom:3mm}
#pdfPrintRoot .years9 .yc .yt{font-size:6.8pt;letter-spacing:.12em;text-transform:uppercase;color:#9a824f;margin-bottom:5mm}
#pdfPrintRoot .years9 .yc .yp{font-family:'Cormorant Garamond',serif;font-size:9.5pt;font-style:italic;border-top:.6pt solid rgba(29,29,27,.18);padding-top:3mm}

#pdfPrintRoot table.mtbl{width:100%;border-collapse:collapse}
#pdfPrintRoot table.mtbl th{font-size:7pt;letter-spacing:.14em;text-transform:uppercase;color:#86857d;text-align:left;padding:0 0 3.2mm;border-bottom:.8pt solid rgba(29,29,27,.35)}
#pdfPrintRoot table.mtbl td{font-size:9pt;padding:3.4mm 0;border-bottom:.5pt solid rgba(29,29,27,.15);color:#3a3a37}
#pdfPrintRoot table.mtbl td:first-child{font-family:'Cormorant Garamond',serif;font-size:11.5pt;color:#1d1d1b}
#pdfPrintRoot table.mtbl td.mn{font-family:'Cormorant Garamond',serif;font-size:13pt}
#pdfPrintRoot table.mtbl td:last-child{font-style:italic;font-family:'Cormorant Garamond',serif;color:#1d1d1b}

#pdfPrintRoot .cal-legend2{display:flex;flex-wrap:wrap;gap:2.5mm 6mm;margin-bottom:6mm}
#pdfPrintRoot .cal-legend2 span{font-size:7pt;letter-spacing:.03em;color:#3a3a37;display:inline-flex;align-items:center;gap:2mm}
#pdfPrintRoot .cal-legend2 i{width:2.6mm;height:2.6mm;border-radius:50%;display:inline-block}
#pdfPrintRoot .cal12{display:grid;grid-template-columns:repeat(3,1fr);gap:4mm 5mm}
#pdfPrintRoot .cal12 .cm{border-top:.7pt solid rgba(29,29,27,.3);padding-top:2mm}
#pdfPrintRoot .cal12 .cm-h{font-family:'Cormorant Garamond',serif;font-size:9pt;text-transform:uppercase;letter-spacing:.1em;text-align:center;margin-bottom:1.6mm}
#pdfPrintRoot .cal-week2{display:grid;grid-template-columns:repeat(7,1fr);margin-bottom:.8mm}
#pdfPrintRoot .cal-week2 span{font-size:5.2pt;text-align:center;color:#86857d;letter-spacing:.02em}
#pdfPrintRoot .cal-days2{display:grid;grid-template-columns:repeat(7,1fr);row-gap:.4mm}
#pdfPrintRoot .cal-d2{text-align:center;line-height:1.05;position:relative}
#pdfPrintRoot .cal-d2 .dd{font-size:4.8pt;color:#86857d;display:block}
#pdfPrintRoot .cal-d2 .pn{font-family:'Cormorant Garamond',serif;font-size:7.4pt;font-weight:600;display:block}
#pdfPrintRoot .cal-d2.today .pn{text-decoration:underline}

#pdfPrintRoot .fit-wrap{transform-origin:top left}

#pdfPrintRoot .pg-footer{position:absolute;left:22mm;right:22mm;bottom:11mm;display:flex;justify-content:space-between;font-size:7pt;letter-spacing:.16em;text-transform:uppercase;color:#86857d;border-top:.5pt solid rgba(29,29,27,.2);padding-top:3.5mm}
`;
const styleEl=document.createElement('style');
styleEl.id='__pdfPrintStyle';
styleEl.textContent=css;
document.head.appendChild(styleEl);

const root=document.createElement('div');
root.id='pdfPrintRoot';

function footer(n){
return `<div class="pg-footer"><span>Spiritum Paris · Numérologie</span><span>Page ${String(n).padStart(2,'0')} / 09</span></div>`;
}
function kicker(l,r){
return `<div class="kicker-row"><span>${l}</span><span>${r}</span></div>`;
}
function fitToPage(pgEl){
const footerEl=pgEl.querySelector('.pg-footer');
const wrap=pgEl.querySelector('.fit-wrap');
if(!footerEl||!wrap)return;
const safetyPx=30;
const footerTop=footerEl.getBoundingClientRect().top;
const wrapRect=wrap.getBoundingClientRect();
const available=footerTop-safetyPx-wrapRect.top;
const natural=wrap.scrollHeight;
if(available>0&&natural>available){
const scale=Math.max(0.6,available/natural);
wrap.style.transform='scale('+scale.toFixed(4)+')';
wrap.style.width=(100/scale).toFixed(3)+'%';
}
}
function colcard(k,val,name,desc){
const c=colorVar(val);
const parf=pf(val);
return `<div class="colcard"><div class="k">${k}</div><div class="big serif" style="color:${c}">${valLabel(val)}</div><div class="nm">${name}</div><div class="desc">${desc}</div><div class="pf">${parf.name}</div></div>`;
}

const p1=document.createElement('div');
p1.className='pg pg-cover';
p1.innerHTML=`<img src="//www.spiritum-paris.com/cdn/shop/files/logo-spiritum-picto-white_45606aac-fd6f-4787-84a6-d012bf59e181_160x.png">
<div class="kicker">Votre thème numérologique</div>
<h1>Un langage secret,<br>écrit dans vos nombres</h1>
<div class="rule"></div>
<div class="nm">${R.first} ${R.last}</div>
<div class="dob">${R.dobFR}</div>
<div class="ed">édité le ${ed}</div>`;
root.appendChild(p1);

const p2=document.createElement('div');
p2.className='pg';
p2.innerHTML=`<div class="pg-content">
${kicker('Essentiel — 01','Vos nombres maîtres')}
<h1 class="pg-title serif">Les trois piliers de votre identité</h1>
<div class="pg-intro">Trois nombres résument l'essentiel de qui vous êtes. Le <strong>chemin de vie</strong> trace votre route et votre mission. L'<strong>expression</strong> révèle vos talents. Le <strong>nombre intime</strong> dévoile vos aspirations les plus profondes.</div>
<div class="fit-wrap"><div class="col3">
${colcard('Chemin de vie',R.cheminVie,NAMES[R.cheminVie]||'',I_VIE[R.cheminVie])}
${colcard('Expression',R.expression,'Votre signature',I_EXPR[R.expression])}
${colcard('Nombre intime',R.ame,'Aspiration profonde',I_EXPR[R.ame])}
</div></div>
${footer(2)}
</div>`;
root.appendChild(p2);

const p3=document.createElement('div');
p3.className='pg';
const now=new Date();
const moisNom=now.toLocaleDateString('fr-FR',{month:'long'});
p3.innerHTML=`<div class="pg-content">
${kicker('Essentiel — 02','Vos énergies du moment')}
<h1 class="pg-title serif">Là où vous en êtes aujourd'hui</h1>
<div class="pg-intro">La numérologie n'éclaire pas seulement votre nature, elle révèle aussi <strong>le moment présent</strong> : les énergies de votre année, de votre mois et de votre jour personnels.</div>
<div class="fit-wrap"><div class="col3">
${colcard('Année personnelle '+R.ty,R.anneePerso,NAMES[R.anneePerso]||'',I_NOW[R.anneePerso])}
${colcard('Mois de '+moisNom,R.moisPerso,NAMES[R.moisPerso]||'',I_NOW[R.moisPerso])}
${colcard('Jour personnel',R.jourPerso,NAMES[R.jourPerso]||'',I_NOW[R.jourPerso])}
</div></div>
${footer(3)}
</div>`;
root.appendChild(p3);

const p4=document.createElement('div');
p4.className='pg';
const cyNames=['Cycle de formation','Cycle de productivité','Cycle de moisson'];
const cyAges=['première partie de vie','milieu de vie','dernière partie de vie'];
const rows3=R.cycles.map((v,i)=>{
const p=pf(v);
return `<div class="row3"><div class="num serif" style="color:${colorVar(v)}">${valLabel(v)}</div><div><div class="meta">${cyNames[i]} · ${cyAges[i]}</div><span class="nmn serif">${NAMES[v]||''}</span><div class="tx">${I_VIE[v]||I_ACTION[v]}</div><div class="pf">${p.name}</div></div></div>`;
}).join('');
p4.innerHTML=`<div class="pg-content">
${kicker('Thème complet — 01','Plan de vie')}
<h1 class="pg-title serif">Les trois grands cycles de votre vie</h1>
<div class="pg-intro">Votre existence se déroule en trois grandes saisons. Le <strong>cycle de formation</strong> pose les bases de votre jeunesse, le <strong>cycle de productivité</strong> couvre le cœur de votre vie adulte, le <strong>cycle de moisson</strong> accompagne la maturité.</div>
<div class="fit-wrap"><div class="rows3">${rows3}</div></div>
${footer(4)}
</div>`;
root.appendChild(p4);

const p5=document.createElement('div');
p5.className='pg';
const inclCells=R.incl.map((v,i)=>`<div class="cell ${v===0?'absent':''}"><span class="idx">${i+1}</span><span class="v serif" style="color:${v===0?'':colorVar(i+1)}">${v}</span></div>`).join('');
const absents=R.incl.map((v,i)=>v===0?i+1:null).filter(x=>x);
const top=R.incl.map((v,i)=>({n:i+1,v})).sort((a,b)=>b.v-a.v)[0];
let inclTxt=`<strong>Votre vibration la plus présente est le ${top.n}</strong> — ${NAMES[top.n]||''} (×${top.v}) : une qualité qui vous est naturelle. `;
inclTxt+=absents.length?`Les nombres absents (${absents.join(', ')}) sont vos <strong>leçons karmiques</strong>.`:`Aucune vibration n'est absente de votre nom — un équilibre rare.`;
p5.innerHTML=`<div class="pg-content">
${kicker('Thème complet — 02',"Champ d'expériences")}
<h1 class="pg-title serif">Votre grille d'inclusion</h1>
<div class="pg-intro">Cette grille compte combien de fois chaque vibration, de 1 à 9, apparaît dans vos prénoms et votre nom de naissance.</div>
<div class="fit-wrap"><div class="incl9">${inclCells}</div>
<div class="note">${inclTxt}</div></div>
${footer(5)}
</div>`;
root.appendChild(p5);

const p6=document.createElement('div');
p6.className='pg';
const total=R.planes.M+R.planes.P+R.planes.E+R.planes.I||1;
const order=['M','P','E','I'];
const barsHTML=order.map(k=>{
const pct=Math.round(R.planes[k]/total*100);
return `<div class="bar-row"><div class="lb">${PLANE_INFO[k].name}</div><div class="bar-track"><div class="bar-fill" style="width:${pct}%"></div></div><div class="vv serif">${R.planRed[k]}</div></div>`;
}).join('');
const dom=order.reduce((a,b)=>R.planes[b]>R.planes[a]?b:a);
p6.innerHTML=`<div class="pg-content">
${kicker('Thème complet — 03',"Plan d'expression")}
<h1 class="pg-title serif">Comment votre énergie se manifeste</h1>
<div class="pg-intro">Nous percevons et exprimons le monde par quatre canaux : le mental, le physique, l'émotif et l'intuitif.</div>
<div class="fit-wrap"><div class="bars4">${barsHTML}</div>
<div class="note"><strong>Plan dominant : ${PLANE_INFO[dom].name}.</strong> ${PLANE_TEXT[dom]}</div></div>
${footer(6)}
</div>`;
root.appendChild(p6);

const p7=document.createElement('div');
p7.className='pg';
const yearsHTML=R.cycle9.map(o=>{
const p=pf(o.val);
return `<div class="yc ${o.year===R.ty?'now':''}"><div class="y">${o.year}</div><div class="yn serif" style="color:${colorVar(o.val)}">${valLabel(o.val)}</div><div class="yt">${NAMES[o.val]||''}</div><div class="yp">${p.name}</div></div>`;
}).join('');
p7.innerHTML=`<div class="pg-content">
${kicker('Thème complet — 04','Cycle de 9 ans')}
<h1 class="pg-title serif">Votre spirale d'années personnelles</h1>
<div class="pg-intro">La numérologie lit le temps par cycles de neuf ans. Voici vos quatre dernières années, l'année en cours (mise en lumière) et les quatre à venir.</div>
<div class="fit-wrap"><div class="years9">${yearsHTML}</div></div>
${footer(7)}
</div>`;
root.appendChild(p7);

const p8=document.createElement('div');
p8.className='pg';
const moisNoms=['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
const monthsRows=moisNoms.map((m,i)=>{
const v=R.moisAnnee[i],p=pf(v);
return `<tr><td>${m}</td><td class="mn" style="color:${colorVar(v)}">${valLabel(v)}</td><td>${NAMES[v]||''}</td><td>${p.name}</td></tr>`;
}).join('');
p8.innerHTML=`<div class="pg-content">
${kicker('Thème complet — 05',"Plan de l'année")}
<h1 class="pg-title serif">Vos douze mois, mois par mois</h1>
<div class="pg-intro">Voici vos douze mois personnels pour <strong>${R.ty}</strong> (année personnelle <strong>${valLabel(R.anneePerso)}</strong>).</div>
<div class="fit-wrap"><table class="mtbl"><thead><tr><th>Mois</th><th>Mois personnel</th><th>Énergie</th><th>Parfum</th></tr></thead><tbody>${monthsRows}</tbody></table></div>
${footer(8)}
</div>`;
root.appendChild(p8);

const p9=document.createElement('div');
p9.className='pg';
const wd=['L','M','M','J','V','S','D'];
const t=new Date(), tY=t.getFullYear(), tM=t.getMonth()+1, tD=t.getDate();
let legend='';
for(let n=1;n<=9;n++){legend+=`<span><i style="background:${colorVar(n)}"></i>${n} · ${NAMES[n]||''}</span>`;}
let calHTML='';
for(let m=1;m<=12;m++){
const pmonth=R.moisAnnee[m-1];
const offset=(new Date(R.ty,m-1,1).getDay()+6)%7;
const ndays=new Date(R.ty,m,0).getDate();
let cells='';
for(let i=0;i<offset;i++)cells+='<div class="cal-d2"></div>';
for(let d=1;d<=ndays;d++){
const pd=reduce1(pmonth+d);
const today=(R.ty===tY&&m===tM&&d===tD);
cells+=`<div class="cal-d2${today?' today':''}"><span class="dd">${d}</span><span class="pn" style="color:${colorVar(pd)}">${pd}</span></div>`;
}
calHTML+=`<div class="cm"><div class="cm-h">${moisNoms[m-1]}</div><div class="cal-week2">${wd.map(w=>`<span>${w}</span>`).join('')}</div><div class="cal-days2">${cells}</div></div>`;
}
p9.innerHTML=`<div class="pg-content">
${kicker('Thème complet — 06','Calendrier numérologique')}
<h1 class="pg-title serif">Votre énergie jour après jour</h1>
<div class="fit-wrap"><div class="cal-legend2">${legend}</div>
<div class="cal12">${calHTML}</div></div>
${footer(9)}
</div>`;
root.appendChild(p9);

document.body.appendChild(root);

const pages=[p1,p2,p3,p4,p5,p6,p7,p8,p9];
pages.forEach(pg=>{ if(pg!==p1) fitToPage(pg); });
try{
const {jsPDF}=window.jspdf;
const pdf=new jsPDF('p','mm','a4');
const pw=pdf.internal.pageSize.getWidth(), ph=pdf.internal.pageSize.getHeight();
for(let i=0;i<pages.length;i++){
if(btn)btn.textContent='Génération '+(i+1)+'/9…';
const canvas=await window.html2canvas(pages[i],{scale:1.6,backgroundColor:'#ffffff',useCORS:true,onclone:pdfClonefix});
if(i>0)pdf.addPage();
pdf.addImage(canvas.toDataURL('image/jpeg',0.9),'JPEG',0,0,pw,ph);
}
const nm=(THEME.fullName||'theme').trim().replace(/\s+/g,'-').toLowerCase();
pdf.save('theme-numerologique-'+nm+'.pdf');
msg.className='lead-msg ok';msg.textContent='Votre thème a été téléchargé en PDF.';
}catch(e){
msg.className='lead-msg ko';msg.textContent='La génération du PDF a échoué. Réessayez.';console.warn(e);
}finally{
if(root.parentNode)root.parentNode.removeChild(root);
if(styleEl.parentNode)styleEl.parentNode.removeChild(styleEl);
if(btn){btn.disabled=false;btn.textContent=old;}
}
}
async function sendThemeEmail(btn){
const msg=document.getElementById('leadMsg');
const email=(THEME&&THEME.email)?THEME.email:'';
if(!THEME||!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){msg.className='lead-msg ko';msg.textContent='Merci de calculer votre thème avant de recevoir votre email.';return false;}
const pf=n=>PARFUMS[n]||PARFUMS[reduceM(n)]||{};const props=THEME?(window.buildV5Props?window.buildV5Props(THEME,{PARFUMS:PARFUMS,NAMES:NAMES,I_VIE:I_VIE,I_ACTION:I_ACTION,PLANE_INFO:PLANE_INFO,PLANE_TEXT:PLANE_TEXT,valLabel:valLabel,reduceM:reduceM,reduce1:reduce1}):{'Prenom':THEME.first||'','Nom':THEME.last||'','Date de naissance':THEME.dobFR||'','Date de naissance ISO':THEME.dobISO||'','Chemin de vie':valLabel(THEME.cheminVie),'Expression':valLabel(THEME.expression),'Nombre intime':valLabel(THEME.ame),'Annee personnelle':valLabel(THEME.anneePerso),'Parfum recommande':(pf(THEME.cheminVie)||{}).name||'','Mois personnel':valLabel(THEME.moisPerso),'Jour personnel':valLabel(THEME.jourPerso),'Source':'Calculateur numerologie'}):{};
const fn=(THEME&&THEME.first)?THEME.first:((THEME&&THEME.fullName)?THEME.fullName.trim().split(/\s+/)[0]:'');
const ln=(THEME&&THEME.last)?THEME.last:'';
const body={data:{type:'subscription',attributes:{custom_source:'Numérologie — site',profile:{data:{type:'profile',attributes:{email:email,first_name:fn,last_name:ln,properties:props}}}},relationships:{list:{data:{type:'list',id:KLAVIYO.listId}}}}};
const evtBody={data:{type:'event',attributes:{properties:props,metric:{data:{type:'metric',attributes:{name:KLAVIYO.metric}}},profile:{data:{type:'profile',attributes:{email:email,first_name:fn,last_name:ln}}}}}};
const old=btn?btn.textContent:''; if(btn){btn.disabled=true;btn.textContent='Envoi…';}
try{
try{ await fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(KLAVIYO.company),{method:'POST',headers:{'Content-Type':'application/json','revision':'2024-10-15'},body:JSON.stringify(body)}); }catch(_){}
const rEvt=await fetch('https://a.klaviyo.com/client/events/?company_id='+encodeURIComponent(KLAVIYO.company),{method:'POST',headers:{'Content-Type':'application/json','revision':'2024-10-15'},body:JSON.stringify(evtBody)});
if(rEvt.ok||rEvt.status===202){msg.className='lead-msg ok';msg.textContent='Merci ! Votre thème vous est envoyé par email à l’instant.';}
else{msg.className='lead-msg ko';msg.textContent='Envoi impossible pour le moment. Réessayez plus tard.';console.warn('Klaviyo',rEvt.status);}
}catch(err){console.warn(err);msg.className='lead-msg ko';msg.textContent='Erreur réseau. Réessayez plus tard.';}finally{ if(btn){btn.disabled=false;btn.textContent=old;} }
return false;
}
(function(){
const cells=[...document.querySelectorAll('#dobCells .dc')];
cells.forEach((c,i)=>{
c.addEventListener('input',e=>{
c.value=c.value.replace(/[^0-9]/g,'').slice(0,1);
if(c.value&&i<cells.length-1)cells[i+1].focus();
});
c.addEventListener('keydown',e=>{
if(e.key==='Backspace'&&!c.value&&i>0){cells[i-1].focus();cells[i-1].value='';e.preventDefault();}
if(e.key==='ArrowLeft'&&i>0)cells[i-1].focus();
if(e.key==='ArrowRight'&&i<cells.length-1)cells[i+1].focus();
if(e.key==='Enter')run();
});
c.addEventListener('paste',e=>{
e.preventDefault();
const digits=(e.clipboardData||window.clipboardData).getData('text').replace(/[^0-9]/g,'').split('');
cells.forEach((cc,j)=>{if(digits[j]!==undefined)cc.value=digits[j];});
const next=Math.min(digits.length,cells.length-1);
cells[next].focus();
});
});
})();

(function(){
var qp=new URLSearchParams(location.search);
if(qp.get('autopdf')!=='1')return;
var fn=qp.get('fn')||'', ln=qp.get('ln')||'', em=qp.get('em')||'', dob=qp.get('dob')||'';
function setVal(sel,val){var el=document.querySelector(sel);if(el){el.value=val;}}
if(fn)setVal('#firstname',fn);
if(ln)setVal('#lastname',ln);
if(em)setVal('#email',em);
if(dob&&dob.length===8){
var cells=[...document.querySelectorAll('#dobCells .dc')];
dob.split('').forEach(function(d,i){if(cells[i])cells[i].value=d;});
}
var ready=new Promise(function(res){if(document.readyState==='complete')res();else window.addEventListener('load',res);});
var fontsReady=(document.fonts&&document.fonts.ready)?document.fonts.ready:Promise.resolve();
Promise.all([ready,fontsReady]).then(function(){
setTimeout(function(){
try{ run(); }catch(e){ console.warn('autopdf run() failed',e); }
setTimeout(function(){
var btn=document.querySelector('[onclick*="downloadPDF"]');
try{ downloadPDF(btn); }catch(e){ console.warn('autopdf downloadPDF() failed',e); }
},700);
},150);
});
})();
